module.exports = __webpack_public_path__ + "r-v3/img/rotate_white.8cbba085.svg";